module.exports = __webpack_public_path__ + "static/media/my.7299f579.svg";